import React from 'react'
import { connect } from 'react-redux'
import FontAwesome from 'react-fontawesome'
import List from '../_List'

const mapStateToProps = state => ({
  list_name: 'Mis Premios',
  empty_message: '¡No has canjeado ningún premio!',
  items: state.user.my_prizes.map(x =>
    ({ ...x,
      id: x.transaction_id,
      text: (
        <div>
          <FontAwesome name="diamond" />
          { ` ${x.credits}` }
        </div>
      ),
    }),
  ),
})

const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(List)



// WEBPACK FOOTER //
// ./src/components/Main/Profile/MyPrizes/index.jsx